import { useUnit } from 'effector-react';
import { CircularProgress } from '@mui/material';
import { $pending } from '../../../../models/detail-sdui';
import * as Styled from '../../styled';

export const Loader = () => {
  const [pending] = useUnit([$pending]);

  if (!pending) return null;

  return (
    <Styled.PaddingContainer>
      <CircularProgress />
    </Styled.PaddingContainer>
  );
};
